export default __webpack_public_path__ + "static/media/slide12.535ee93e.jpg";